import { Paginated } from 'types/paginated';
import { IChat, IMessage } from 'views/types/support';
import { $api } from './interceptor';

const supportApi = () => {
  const getChats = async (
    search: string,
    sort: 'all' | 'recent' | 'oldest'
  ) => {
    const { data } = await $api.get<Paginated<IChat>>('/api/chats', {
      params: {
        limit: Number.MAX_SAFE_INTEGER,
        sortBy: 'createdAt:DESC',
        search,
        sort,
      },
    });

    return data;
  };

  const getMessages = async (chatId: string) => {
    const { data } = await $api.get<Paginated<IMessage>>(`/api/messages`, {
      params: {
        limit: Number.MAX_SAFE_INTEGER,
        sortBy: 'createdAt:ASC',
        'filter.chat.id': `$eq:${chatId}`,
      },
    });

    return data;
  };

  const sendMessage = async (chatId: string, content: string) => {
    const { data } = await $api.post(`/api/messages/send`, {
      chatId,
      content,
    });

    return data;
  };

  const leaveChat = async (chatId: string) => {
    const { data } = await $api.put(`/api/chats/leave`, {
      chatId,
    });

    return data;
  };

  return {
    getChats,
    getMessages,
    sendMessage,
    leaveChat,
  };
};

export const supportService = supportApi();
